import { useState, useEffect } from "react";
import axios from "axios";

import API_URL from "../config/config";
import AdminSidebar from "../components/AdminSidebar";
import "../css/admin.css";
import { useNavigate } from "react-router-dom";

function AddProduct(){

    const [product,setProduct] = useState({

        product_name:"",
        category:"",
        brand:"",
        description:"",
        price:"",
        stock:"",
        image:"",
        status:"Active",
        old_price:"",
        discount:0,
        is_new:1,
        is_featured:1,
        is_trending:0

    });

const navigate = useNavigate();

useEffect(() => {

    const role = localStorage.getItem("role");

    if (role !== "admin") {

        alert("Access Denied");

        navigate("/");

    }

}, [navigate]);

    const handleChange=(e)=>{

        setProduct({

            ...product,

            [e.target.name]:e.target.value

        });

    };



const uploadImage = (e)=>{


const file = e.target.files[0];


const formData = new FormData();


formData.append(
    "image",
    file
);



axios

.post(
    `${API_URL}/upload`,
    formData,
    {
        headers:{
            "Content-Type":"multipart/form-data"
        }
    }
)

.then((res)=>{


    setProduct({

        ...product,

        image:res.data.image

    });


    alert("Image Uploaded");


})


.catch((err)=>{

    console.log(err);

    alert("Image Upload Failed");

});


};

    const addProduct=(e)=>{

        e.preventDefault();


      axios.post(
    `${API_URL}/admin/products`,
    product,
    {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    }
)
        .then((res)=>{


            alert("Product Added Successfully");


            setProduct({

                product_name:"",
                category:"",
                brand:"",
                description:"",
                price:"",
                stock:"",
                image:"",
                status:"Active",
                old_price:"",
                discount:0,
                is_new:1,
                is_featured:1,
                is_trending:0

            });


        })


        .catch((err)=>{

            console.log(err);

            alert("Product Add Failed");

        });


    };





return(

<div className="admin-layout">


<AdminSidebar />



<div className="admin-content">


<h1>
Add New Product
</h1>



<form 
className="edit-product-box"
onSubmit={addProduct}
>




<input

name="product_name"

placeholder="Product Name"

value={product.product_name}

onChange={handleChange}

required

/>





<input

name="category"

placeholder="Category"

value={product.category}

onChange={handleChange}

required

/>





<input

name="brand"

placeholder="Brand"

value={product.brand}

onChange={handleChange}

/>






<textarea

name="description"

placeholder="Product Description"

value={product.description}

onChange={handleChange}

/>






<input

type="number"

name="price"

placeholder="Price"

value={product.price}

onChange={handleChange}

required

/>






<input

type="number"

name="old_price"

placeholder="Old Price"

value={product.old_price}

onChange={handleChange}

/>






<input

type="number"

name="discount"

placeholder="Discount %"

value={product.discount}

onChange={handleChange}

/>






<input

type="number"

name="stock"

placeholder="Stock"

value={product.stock}

onChange={handleChange}

/>






<input

type="file"

accept="image/*"

onChange={uploadImage}

/>







<select

name="status"

value={product.status}

onChange={handleChange}

>

<option value="Active">
Active
</option>


<option value="Inactive">
Inactive
</option>


</select>






<button

className="edit-btn"

type="submit"

>

Add Product

</button>





</form>




</div>


</div>


);


}


export default AddProduct;